import React, { useState, useEffect } from 'react';
import './../css/marketpricedb.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './../css/insights.scss';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import Axios from 'axios';
import { API_INSIGHT } from '../api/api';
import LoginModal from '../components/LoginModal';
import InsightModal from '../components/InsightModal';
import InsightModalMobile from '../components/InsightModalMobile';
import { useHistory, useLocation } from 'react-router';
import Sidebar from '../components/Sidebar';
import BottomNav from '../components/BottomNav';
import TopNav from '../components/TopNav';
import InsightWidget from '../components/InsightWidget';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { addWidgetFailed, addWidgetSuccess, deleteWidgetSuccess, visitInsightMenu } from '../services/amplitude';
import { createNewObjInsight, nameChartType } from '../helper';
import { title } from '../constant/title';
import { CONFIG_AUTH } from '../utils/API';
import useCheckAuth from '../hooks/useCheckAuth';

const Insights = () => {
  const history = useHistory();
  const location = useLocation();

  const MySwal = withReactContent(Swal);

  const [widget, setWidget] = useState([]);
  const [openEditor, setOpenEditor] = useState({
    isOpen: false,
    type: 'add',
  });

  const [selectedWidget, setSelectedWidget] = useState(null);

  const pageChannel = location.state && location.state.pageChannel;

  const { userId } = useCheckAuth({ showModalCheckPremium: true })

  useEffect(() => {
    visitInsightMenu(pageChannel);

    if (userId != null) {
      Axios.post(
        API_INSIGHT.chart_profile,
        { user_id: `${userId}421563788` },
        {
          headers: {
            ...CONFIG_AUTH,
          },
        }
      ).then((res) => {

        const data = res.data.data;

        data.map((item) => {
          let text = JSON.stringify(item.value);
          text = Array.isArray(text) ? JSON.parse(text) : JSON.parse(JSON.parse(text));
          text.map((item1) => {
            item1.map((item2) => {
              setWidget((oldValue) => [...oldValue, item2]);
            });
          });
        });
      }).catch(error => {
        console.log('error', error.response);
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const addWidget = (data) => {
    setWidget((oldValue) => [...oldValue, data]);

    let temp = [];
    temp.push(data);

    Axios.post(
      API_INSIGHT.chart_profile,
      { user_id: `${localStorage.getItem('id')}421563788` },
      {
        headers: {
          ...CONFIG_AUTH,
        },
      }
    ).then((res) => {
      const data = res.data.data;

      addWidgetSuccess({
        widget_name: temp && temp[0].name,
        chart_type: temp && nameChartType(temp[0].chartType),
        data_display: temp && title(temp[0].metric),
        auction_period: temp && `${temp[0].period && temp[0].period} Bulan`,
        filters: temp && createNewObjInsight(temp[0].filters),
      });

      data.map((item) => {
        let text = JSON.stringify(item.value);
        text = Array.isArray(text) ? JSON.parse(text) : JSON.parse(JSON.parse(text));
        text.map((item1, i) => {
          item1.map((item2) => {
            temp.push(item2);
          });
        });
      });

      Axios.patch(
        API_INSIGHT.update_profile,
        {
          user_id: `${localStorage.getItem('id')}421563788`,
          key: 'default',
          value: JSON.stringify([temp]),
        },
        {
          headers: {
            ...CONFIG_AUTH,
          },
        }
      )
        .then(() => {
        })
        .catch(() => { })
        .finally(() => { });
    });
  };

  const deleteWidget = ({ data }) => {
    let id = data.id;
    const widget = data;

    MySwal.fire({
      title: 'Hapus Widget?',
      icon: 'warning',
      text: 'Widget yang telah dihapus tidak dapat dikembalikan',
      showDenyButton: true,
      denyButtonText: 'Batal',
      confirmButtonText: 'Hapus',
      confirmButtonColor: '#82be2a',
      denyButtonColor: ' #FF0000',
    }).then((result) => {
      if (result.isConfirmed) {
        Axios.post(
          API_INSIGHT.chart_profile,
          { user_id: `${localStorage.getItem('id')}421563788` },
          {
            headers: {
              ...CONFIG_AUTH,
            },
          }
        ).then((res) => {
          const data = res.data.data;
          deleteWidgetSuccess({
            widget_name: widget && widget.name,
            chart_type: widget && nameChartType(widget.chartType),
            data_display: widget && title(widget.metric),
            auction_period: widget && `${widget.period && widget.period} Bulan`,
            filters: widget && createNewObjInsight(widget.filters),
          });

          let temp = [];

          data.map((item) => {
            let text = JSON.stringify(item.value);
            text = Array.isArray(text) ? JSON.parse(text) : JSON.parse(JSON.parse(text));
            text.map((item1, i) => {
              item1.map((item2) => {
                temp.push(item2);
              });
            });
          });

          temp = temp.filter((item) => item.id !== id);

          const form_data = {
            key: 'default',
            value: JSON.stringify([temp]),
            user_id: `${localStorage.getItem('id')}421563788`,
          };

          Axios.patch(API_INSIGHT.update_profile, form_data, {
            headers: {
              ...CONFIG_AUTH,
            },
          })
            .then((res) => {
              window.location.reload();
            })
            .catch((err) => { });
        });
      }
    });
  };

  const editWidget = (data) => {
    let id = data.id;
    let new_data = data;

    Axios.post(
      API_INSIGHT.chart_profile,
      { user_id: `${localStorage.getItem('id')}421563788` },
      {
        headers: {
          ...CONFIG_AUTH,
        },
      }
    ).then((res) => {
      const data = res.data.data;
      let temp = [];

      data.map((item) => {
        let text = JSON.stringify(item.value);
        text = Array.isArray(text) ? JSON.parse(text) : JSON.parse(JSON.parse(text));
        text.map((item1, i) => {
          item1.map((item2) => {
            temp.push(item2);
          });
        });
      });

      temp = temp.filter((item) => item.id !== id);
      temp.push(new_data);

      Axios.patch(
        API_INSIGHT.update_profile,
        {
          user_id: `${localStorage.getItem('id')}421563788`,
          key: 'default',
          value: JSON.stringify([temp]),
        },
        {
          headers: {
            ...CONFIG_AUTH,
          },
        }
      )
        .then((res) => {
          window.location.reload();
        })
        .catch((err) => {
          addWidgetFailed({
            status_message: err.response.statusText,
            status_code: err.response.status,
          });
        })
        .finally(() => { });
    });
  };

  return (
    <div>
      <LoginModal pageChannel="Insight" />
      <div className="container-fluid main-marketpricedb">
        <InsightModal addWidget={addWidget} />
        {widget.map((item, i) => {
          return <InsightModal key={i} data={item} editWidget={editWidget} />;
        })}
        <TopNav pageChannel="Insight" />
        <div className="row" style={{ minHeight: '93vh' }}>
          <Sidebar pageChannel="Insight" />
          <div className="col-xl-10 col-lg-12 pt-3 insight-content">
            <div className="container-fluid card py-3" style={{ flex: 1 }}>
              <div className="row">
                <div className="col-xl-12">
                  <button
                    className="btn-overview-green-solid"
                    style={{ fontSize: '15px', width: '200px' }}
                    data-target="#modal-insight"
                    data-toggle="modal"
                  >
                    <FontAwesomeIcon icon={faPlus} className="mr-3" />
                    Tambah Widget
                  </button>
                </div>
              </div>
              <div className="row">
                {widget.map((item, i) => {
                  return <InsightWidget key={i} deleteWidget={deleteWidget} data={item} />;
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="main-insight-mobile">
        {openEditor.isOpen ? (
          <InsightModalMobile
            data={selectedWidget}
            addWidget={addWidget}
            editWidget={editWidget}
            openEditor={openEditor}
            setOpenEditor={setOpenEditor}
            setSelectedWidget={setSelectedWidget}
          />
        ) : (
          <div className="container-fluid">
            <BottomNav history={history} />
            <div className="row bg-light d-flex flex-column">
              <div className="col-12 pt-3 pb-2 d-flex px-4 header bg-white">
                <h4 style={{ fontSize: '6vw' }}>Insights</h4>
              </div>
              <button
                className="btn-overview-green-solid ml-3 mt-4"
                style={{ fontSize: '15px', width: '200px' }}
                onClick={() => setOpenEditor({ type: 'add', isOpen: true })}
              >
                <FontAwesomeIcon icon={faPlus} className="mr-3" />
                Tambah Widget
              </button>
              <div className="px-3 mt-4">
                {widget.map((item, i) => {
                  return (
                    <InsightWidget
                      setSelectedWidget={setSelectedWidget}
                      openEditor={openEditor}
                      setOpenEditor={setOpenEditor}
                      key={i}
                      deleteWidget={deleteWidget}
                      data={item}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Insights;
